import { ErrorType, LoadedType, RequestType } from 'common/actions/asanaSettings';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
